"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; //TODO: Can probably split actions and types too..?


exports.default = meta;

var _MetaActionTypes = require("../constants/action-types/MetaActionTypes");

var types = _interopRequireWildcard(_MetaActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
} // NOTE: really experimental fix for passing across info to front-end redux


var atob = typeof window !== "undefined" ? window.atob : function (a) {
  return new Buffer(a, "base64").toString("binary");
};
var isAuthenticated = false;
var username = void 0;
var userRole = void 0;

if (typeof localStorage !== "undefined") {
  var token = localStorage.getItem("soc-token");

  if (token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    var info = JSON.parse(atob(base64));
    isAuthenticated = Boolean(token);
    username = info.username;
    userRole = info.role;
  }
}

var initialState = {
  initialised: false,
  isAuthenticated: isAuthenticated,
  feedbackSubmitted: false,
  username: username,
  userRole: userRole,
  friends: [],
  requests: [],
  sent: []
};

function meta() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case types.INITIALISE_GAME:
      return initialiseGame(meta);

    case types.FEEDBACK_SUBMITTED:
      return feedbackSubmitted(meta);

    case types.LOADING_REQUEST:
      return loadingRequest(meta);

    case types.LOGIN_SUCCESS:
      return login(meta, payload);

    case types.REGISTER_SUCCESS:
      return register(meta, payload);

    case types.LOGOUT_SUCCESS:
      return logout(meta, payload);

    case types.PASSWORD_RESET_SUCCESS:
      return passwordReset(meta, payload);

    case types.FORGOTTEN_PASSWORD_SUCCESS:
      return forgottenPassword(meta, payload);
    //TODO: handle all the errors :(

    case types.LOGIN_FAILURE:
    case types.FORGOTTEN_PASSWORD_FAILURE:
    case types.PASSWORD_RESET_FAILURE:
    case types.REGISTER_FAILURE:
      return handleFailure(meta, payload);

    case types.CLEAR_META_ERROR:
      return clearMetaError(meta);

    case types.GET_FRIENDS_SUCCESS:
      return storeFriendsList(meta, payload);

    case types.GET_FRIEND_REQUESTS_SUCCESS:
      return storeFriendRequests(meta, payload);

    case types.SENT_FRIEND_REQUEST_SUCCESS:
      return updateSentRequests(meta, payload);

    case types.GET_SENT_REQUEST_SUCCESS:
      return storeSentRequests(meta, payload);

    case types.ACCEPT_FRIEND_REQUEST_SUCCESS:
      return updateFriends(meta, payload);

    case types.DECLINE_FRIEND_REQUEST_SUCCESS:
      return meta;

    case types.STORE_AVATAR_URL_SUCCESS:
      return storeAvatar(meta, payload);

    case types.UPDATE_FRIENDS_INFO:
      return updateFriendsInfo(meta, payload);

    case types.UPDATE_ARRAYS:
      return updateArrays(meta, payload);

    case types.FRIEND_ERROR:
      return storeFriendError(meta, payload);

    case types.RESET_FRIEND_ERROR:
      return resetFriendError(meta);

    default:
      return meta;
  }
}

var loadingRequest = function loadingRequest(meta) {
  return _extends({}, meta, {
    isFetching: true
  });
};

var passwordReset = function passwordReset(meta, payload) {
  return _extends({}, meta, payload);
};

var forgottenPassword = function forgottenPassword(meta, payload) {
  return _extends({}, meta, payload);
};

var handleFailure = function handleFailure(meta, payload) {
  return _extends({}, meta, payload);
};

var clearMetaError = function clearMetaError(meta) {
  return _extends({}, meta, {
    metaError: ""
  });
};

var storeFriendError = function storeFriendError(meta, _ref2) {
  var message = _ref2.message;
  return _extends({}, meta, {
    friendError: message
  });
};

var resetFriendError = function resetFriendError(meta) {
  return _extends({}, meta, {
    friendError: ""
  });
};

var storeAvatar = function storeAvatar(meta, _ref3) {
  var url = _ref3.url;
  return _extends({}, meta, {
    avatar: url
  });
};

var updateFriendsInfo = function updateFriendsInfo(meta, payload) {
  return _extends({}, meta, payload);
};

var updateArrays = function updateArrays(meta, _ref4) {
  var name = _ref4.name,
      action = _ref4.action;

  if (action === "accept") {
    var index = meta.requests.findIndex(function (r) {
      return r.username === name;
    });
    return _extends({}, meta, {
      requests: [].concat(_toConsumableArray(meta.requests.slice(0, index)), _toConsumableArray(meta.requests.slice(index + 1))),
      friends: [].concat(_toConsumableArray(meta.requests), [{
        username: name
      }])
    });
  }

  if (action === "decline") {
    var _index = meta.requests.findIndex(function (r) {
      return r.username === name;
    });

    return _extends({}, meta, {
      requests: [].concat(_toConsumableArray(meta.requests.slice(0, _index)), _toConsumableArray(meta.requests.slice(_index + 1)))
    });
  }
};

var storeFriendsList = function storeFriendsList(meta, _ref5) {
  var friends = _ref5.friends;
  return _extends({}, meta, {
    friends: friends
  });
};

var updateSentRequests = function updateSentRequests(meta, _ref6) {
  var name = _ref6.name;
  return _extends({}, meta, {
    sent: [].concat(_toConsumableArray(meta.sent), [{
      username: name
    }])
  });
};

var storeFriendRequests = function storeFriendRequests(meta, _ref7) {
  var requests = _ref7.requests;
  return _extends({}, meta, {
    requests: requests
  });
};

var storeSentRequests = function storeSentRequests(meta, _ref8) {
  var sent = _ref8.sent;
  return _extends({}, meta, {
    sent: sent
  });
};

var updateFriends = function updateFriends(meta, _ref9) {
  var name = _ref9.name;
  return _extends({}, meta, {
    friends: [].concat(_toConsumableArray(meta.friends), [{
      username: name
    }])
  });
};

var initialiseGame = function initialiseGame(meta) {
  return _extends({}, meta, {
    initialised: true
  });
};

var feedbackSubmitted = function feedbackSubmitted(meta) {
  return _extends({}, meta, {
    feedbackSubmitted: true
  });
};

var login = function login(meta, payload) {
  return _extends({}, meta, payload, {
    metaError: ""
  });
};

var register = function register(meta, payload) {
  return _extends({}, meta, payload, {
    metaError: ""
  });
};

var logout = function logout(meta, payload) {
  return _extends({}, meta, payload, {
    isAuthenticated: false,
    username: undefined,
    userRole: undefined
  });
};